/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { Alarm } from '../models';
/**
 * AlarmApi - axios parameter creator
 * @export
 */
export const AlarmApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Retrieves all alarms for a specific device
     * @param {string} device_id The unique identifier of the device
     * @param {number} [weeks] Optional weeks number to filter alarms by. If not provided, all alarms will be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    alarmControllerFindAllAlarmOfDevice: async (
      device_id: string,
      weeks?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'device_id' is not null or undefined
      if (device_id === null || device_id === undefined) {
        throw new RequiredError(
          'device_id',
          'Required parameter device_id was null or undefined when calling alarmControllerFindAllAlarmOfDevice.'
        );
      }
      const localVarPath = `/alarm/device/{device_id}`.replace(
        `{${'device_id'}}`,
        encodeURIComponent(String(device_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (weeks !== undefined) {
        localVarQueryParameter['weeks'] = weeks;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves all alarms for a specific device
     * @param {string} device_id The unique identifier of the device
     * @param {string} date Date in &#x60;YYYY-MM-DD&#x60; format to filter alarms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    alarmControllerFindAllAlarmOfDevicePerDay: async (
      device_id: string,
      date: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'device_id' is not null or undefined
      if (device_id === null || device_id === undefined) {
        throw new RequiredError(
          'device_id',
          'Required parameter device_id was null or undefined when calling alarmControllerFindAllAlarmOfDevicePerDay.'
        );
      }
      // verify required parameter 'date' is not null or undefined
      if (date === null || date === undefined) {
        throw new RequiredError(
          'date',
          'Required parameter date was null or undefined when calling alarmControllerFindAllAlarmOfDevicePerDay.'
        );
      }
      const localVarPath = `/alarm/device/{device_id}/per-day`.replace(
        `{${'device_id'}}`,
        encodeURIComponent(String(device_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] = date;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AlarmApi - functional programming interface
 * @export
 */
export const AlarmApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Retrieves all alarms for a specific device
     * @param {string} device_id The unique identifier of the device
     * @param {number} [weeks] Optional weeks number to filter alarms by. If not provided, all alarms will be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async alarmControllerFindAllAlarmOfDevice(
      device_id: string,
      weeks?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<Alarm>>>
    > {
      const localVarAxiosArgs = await AlarmApiAxiosParamCreator(
        configuration
      ).alarmControllerFindAllAlarmOfDevice(device_id, weeks, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves all alarms for a specific device
     * @param {string} device_id The unique identifier of the device
     * @param {string} date Date in &#x60;YYYY-MM-DD&#x60; format to filter alarms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async alarmControllerFindAllAlarmOfDevicePerDay(
      device_id: string,
      date: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<Alarm>>>
    > {
      const localVarAxiosArgs = await AlarmApiAxiosParamCreator(
        configuration
      ).alarmControllerFindAllAlarmOfDevicePerDay(device_id, date, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * AlarmApi - factory interface
 * @export
 */
export const AlarmApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Retrieves all alarms for a specific device
     * @param {string} device_id The unique identifier of the device
     * @param {number} [weeks] Optional weeks number to filter alarms by. If not provided, all alarms will be returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async alarmControllerFindAllAlarmOfDevice(
      device_id: string,
      weeks?: number,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<Alarm>>> {
      return AlarmApiFp(configuration)
        .alarmControllerFindAllAlarmOfDevice(device_id, weeks, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves all alarms for a specific device
     * @param {string} device_id The unique identifier of the device
     * @param {string} date Date in &#x60;YYYY-MM-DD&#x60; format to filter alarms
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async alarmControllerFindAllAlarmOfDevicePerDay(
      device_id: string,
      date: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<Alarm>>> {
      return AlarmApiFp(configuration)
        .alarmControllerFindAllAlarmOfDevicePerDay(device_id, date, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AlarmApi - object-oriented interface
 * @export
 * @class AlarmApi
 * @extends {BaseAPI}
 */
export class AlarmApi extends BaseAPI {
  /**
   *
   * @summary Retrieves all alarms for a specific device
   * @param {string} device_id The unique identifier of the device
   * @param {number} [weeks] Optional weeks number to filter alarms by. If not provided, all alarms will be returned
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlarmApi
   */
  public async alarmControllerFindAllAlarmOfDevice(
    device_id: string,
    weeks?: number,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<Alarm>>> {
    return AlarmApiFp(this.configuration)
      .alarmControllerFindAllAlarmOfDevice(device_id, weeks, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves all alarms for a specific device
   * @param {string} device_id The unique identifier of the device
   * @param {string} date Date in &#x60;YYYY-MM-DD&#x60; format to filter alarms
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AlarmApi
   */
  public async alarmControllerFindAllAlarmOfDevicePerDay(
    device_id: string,
    date: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<Alarm>>> {
    return AlarmApiFp(this.configuration)
      .alarmControllerFindAllAlarmOfDevicePerDay(device_id, date, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
